(function ($) {

	// Elements
	let $filters_form = $('.archive-product-filters'),
		$active_filters_container = $('.products_archive__filtered'),
		$price_slider = []

	$(document).gp_ready(function () {
		$('.toggle-filter').off("click").click(function () {

			if (window.innerWidth >= 768 || $(this).closest("#sidebar-filters").length > 0) { // Desktop

				// Toggle open/close on click
				let $filter = $(this).closest('.toggle-filter-wrapper')
				toggle_filter($filter);

			} else { // Phones

				// Open modal
				$(document).trigger("open_modal", "product-catalog-filters")

				// Open filter
				let filter_name = $(this).data('name')
				let $filter = $("#sidebar-filters").find("[data-name='" + filter_name + "']").closest('.toggle-filter-wrapper')
				toggle_filter($filter)

			}

		})
	})

	function toggle_filter($filter) {
		if (!$filter.hasClass('opened')) {
			open_filter($filter)
		} else {
			close_filter($filter)
		}
	}

	function open_filter($filter) {
		setTimeout(() => {
			if ($filter.parents('.products_archive__filters').length) {
				$('body').trigger('show_overlay')
			}
			$filter.addClass('opened');
			$filter.children('.toggle-filter__dropdown').slideDown(100);

			// Sidebar - Animate scroll to better Y position
			setTimeout(function () {
				let $scroll_section = $filter.closest(".sidebar__filters")
				if ($scroll_section.length > 0) {
					$scroll_section.animate({
						scrollTop: $filter.offset().top + $scroll_section.scrollTop() - $filter.offsetParent().offset().top - 120
					}, 300)
				}
			}, 100)

		}, 1)
	}

	function close_filter($filter) {
		if ($filter.parents('.products_archive__filters').length) {
			$('body').trigger('hide_overlay');
		}
		$filter.removeClass('opened');
		$filter.children('.toggle-filter__dropdown').slideUp(100);
	}


	// Close filter on body overlay click
	$(document).on("click", "", function (e) {
		if (!e.target.closest(".toggle-filter-wrapper")) {
			close_filter($(".toggle-filter-wrapper"))
		}
	})

	// Close modal on Escape
	$(document).keyup(function (e) {
		if (e.key === "Escape") {
			close_filter($('.toggle-filter-wrapper'))
		}
	});

	// Order - close on change
	$(".products_archive__filter-order input[name='orderby']").click(function () {
		close_filter($(this).closest('.products_archive__filter'))
	})


	function reset_filters() {

		// Reset checkboxes
		$filters_form.find("input[type='checkbox'], input[type='radio']").prop("checked", false)

		// Reset range
		if ($price_slider.length > 0) {
			var price_min = $price_slider[0].data('slider-min'),
				price_max = $price_slider[0].data('slider-max')

			$price_slider[0].bootstrapSlider('setValue', [price_min, price_max]);
			$price_slider[0].trigger('change')
		}

		// Update form
		$filters_form.trigger('change')
	}

	$('.archive-product-filter-reset').click(reset_filters)

	function uncheck_filter(name, value) {
		$filters_form.find("[name='" + name + "'][value='" + value + "']").prop("checked", false)
	}

	function set_active_labels() {
		set_site_active_filters()
		set_sidebar_active_filters()
	}

	function set_site_active_filters() {

		$active_filters_container.empty()
		let active_filters = 0;

		if ($price_slider.length > 0) {

			let $myslider = $price_slider[0]

			// Add price range slider labels
			var range_price = $myslider.bootstrapSlider('getValue')

			var price_from = range_price[0],
				price_min = $myslider.data('slider-min'),
				price_to = range_price[1],
				price_max = $myslider.data('slider-max')

			// From
			if (price_from != price_min) {
				active_filters++
				var price_from_label = $("<button class=\"products_archive__filtered-btn\">Od: " + price_from + " Kč</button>").appendTo($active_filters_container)
				// Bind click to remove
				price_from_label.click(function () {
					$myslider.bootstrapSlider('setValue', [price_min, price_to]);
					$myslider.trigger('change')
					$filters_form.trigger('change')
				})
			}

			// To
			if (price_to != price_max) {
				active_filters++
				var price_to_label = $("<button class=\"products_archive__filtered-btn\">Do: " + price_to + " Kč</button>").appendTo($active_filters_container)
				// Bind click to remove
				price_to_label.click(function () {
					$myslider.bootstrapSlider('setValue', [price_from, price_max]);
					$myslider.trigger('change')
					$filters_form.trigger('change')
				})
			}
		}

		// Add selected checkboxes filter labels
		var $active_filters = $filters_form.eq(0).find("input[type='checkbox']:checked, input[type='radio']:checked")

		$active_filters.each(function () {

			if ($(this).val() !== "") {
				active_filters++
				var new_label = $("<button class=\"products_archive__filtered-btn\">" + $(this).data('label') + "</button>");
                if($(this).closest('[translate="no"]').length){ // keep translation
                    new_label.attr('translate', 'no');
                }

                new_label.appendTo($active_filters_container);
				new_label.data('checkbox', $(this))
				// Bind click to remove
				new_label.click(function () {
					let $checkbox = $(this).data('checkbox')
					uncheck_filter($checkbox.attr("name"), $checkbox.attr("value"))
					$filters_form.trigger("change")
				})
			}

		})

		// Add active filter class and "Clear all filters" button
		if (active_filters > 0) {
			$active_filters_container.addClass('products_archive__filtered-use');
			$("<button class=\"products_archive__filtered-clear archive-product-filter-reset\">" + $('.products_archive__filtered').data('clear-text') + "</button>").appendTo($active_filters_container)
		} else {
			$active_filters_container.removeClass('products_archive__filtered-use');
		}

		// Bind reset
		$('.archive-product-filter-reset').click(reset_filters)

	}

	function set_sidebar_active_filters() {
		$(".sidebar__filters__filter, .sidebar__filters-form .products_archive__filter-order").each(function () {
			let $active_filters = $(this).find("input[type='checkbox']:checked, input[type='radio']:checked")
			let active_filters = []
			$active_filters.each(function () {
				active_filters.push($(this).data("label"))
			})
			$(this).find(".products_archive__filter-result").text(active_filters.join(", "))
		})
	}

	function sync_forms() {

		// Sync checkboxes, radio buttons
		$filters_form.find("input[type='checkbox'], input[type='radio']").change(function () {
			let name = $(this).attr("name")
			let value = $(this).attr("value")
			let is_checked = $(this).is(":checked")
			$filters_form.find("[name='" + name + "'][value='" + value + "']").prop("checked", is_checked)
		})

	}

	// Filtration price
	$(document).gp_ready(function () {

		// Filtration FE
		$(".filtration__range-input").focusout(function () {
			$(this).find(".filtration__range-label").css("opacity", "1");
		})
		$(".filtration__range-input").focusin(function () {
			$(this).find(".filtration__range-label").css("opacity", "0");
		})

		$price_slider = []
		$(".price-slider").each(function () {
			var $myslider = $(this);
			$myslider.bootstrapSlider();

			$myslider.on("change", function () {

				var value = $myslider.bootstrapSlider('getValue')
				for (var i = 0; i < value.length; ++i) {
					var $input = $("input.sliderValue[data-index=" + i + "]");
					$input.val(value[i]);
					$input.parent().find(".filtration__range-label").html(value[i] + "<span> Kč</span>");
				}

				// Sync values with sidebar
				$price_slider.forEach((slider) => {
					slider.bootstrapSlider("setValue", value)
				})

			});

			// change value of range when change
			$(this).closest(".filtration__range").find("input.sliderValue").change(function () {

				let $range = $(this).closest(".filtration__range")

				// Set min and max number
				let max = parseInt($(this).attr('max'));
				let min = parseInt($(this).attr('min'));

				// Validate input
				let from = parseInt($range.find(".sliderValue[data-index='0']").val())
				let to = parseInt($range.find(".sliderValue[data-index='1']").val())

				if (from > to) {
					to = from + 1
				}

				if (from < min) {
					from = min
				}

				if (to > max) {
					to = max
				}

				$myslider.bootstrapSlider('setValue', [from, to]);
				$myslider.trigger("change")

			});

			$price_slider.push($myslider)
			set_active_labels()

		});

	});


	// Set active labels
	set_active_labels()
	sync_forms()
	$filters_form.change(set_active_labels)
	$(document).on("ajax_products_loaded", set_active_labels)
	$(document).on("ajax_products_loaded", sync_forms)

})(jQuery);
